import { AllessehContent } from 'hooks/useAllessehContentQuery';
import { SnippetyImageData, VideoDataForSummarian } from 'hooks/useSnippetyQuery';
import { defaultImage } from 'utils/article';
import { AddIframeData } from './components/add-iframe-modal/AddIframeModal';
import { MediaTypes } from './components/media-input/MediaInput.utils';

import { AltSummFields, EMPTY_IFRAME } from 'contexts/summarian/summarian.utils';

export function buildIframeFromAddIframeData(data: AddIframeData): IframeAltSumm {
  return {
    type: 'inset',
    inset_type: 'IFRAME',
    properties: {
      url: data.iframeUrl,
      fallback: {
        type: 'image',
        url: data.fallbackImageUrl,
        link_url: data.fallbackLinkUrl,
        ...(data.fallbackLinkText ? { link_text: data.fallbackLinkText } : {})
      }
    }
  };
}

export interface ControlledAltSumm {
  headline: string;
  body: string;
  flashline: string;
  image: SnippetyImageData[];
  video: VideoDataForSummarian[];
  imageUrl: string; // we don't send this property to Summarian, we only use it to display the image in the modal
  imageCredit: string; // we don't send this property to Summarian, we only use it to display the image in the modal
  videoUrl: string; // we also do not send this to Summarian, only use it to display the video in the modal
  videoImage: string; // we do not send this to Summarian, only use it to display the video image
  bullets: string[];
  subhead: string;
  chartlosId: string;
  chart: string;
  iframe: IframeAltSumm;
}

export const DEFAULT_CONTROLLED_ALT_SUMM: ControlledAltSumm = {
  headline: '',
  body: '',
  flashline: '',
  subhead: '',
  bullets: [],
  image: [],
  video: [],
  imageUrl: '',
  imageCredit: '',
  videoUrl: '',
  videoImage: '',
  chart: '',
  chartlosId: '',
  iframe: EMPTY_IFRAME
};

export const DEFAULT_MEDIA_ALT_SUMM = {
  image: [],
  video: [],
  imageUrl: '',
  videoUrl: '',
  videoImage: '',
  chart: '',
  chartlosId: '',
  iframe: EMPTY_IFRAME
};

export function getUrlToShowType(altSummFields?: Partial<AltSummFields> | null): MediaTypes {
  if (!altSummFields) {
    return '';
  }
  const { image, video, chartlosId, iframe } = altSummFields;
  if (iframe?.properties.url) {
    return 'iframe';
  }

  if (video) {
    return 'video';
  }
  if (chartlosId) {
    return 'chart';
  }
  if (image) {
    return 'image';
  }
  return '';
}

export function getUrlToShow(
  altSummFields: Partial<AltSummFields> | null,
  allessehContent: AllessehContent | null = null
): string {
  if (!altSummFields) {
    return '';
  }
  const { image, videoImage, video, chart, chartlosId, iframe } = altSummFields;
  if (iframe?.properties.fallback.url) {
    return iframe.properties.fallback.url;
  }
  if (videoImage && video) {
    return videoImage;
  }
  if (chart && chartlosId) {
    return chart;
  }
  if (image?.length) {
    return image;
  }
  if (allessehContent) {
    return defaultImage(allessehContent) ?? '';
  }
  return '';
}
